module.exports = __webpack_public_path__ + "media/images/crypto-currencies/litecoin-6bcd978cdfa87575b8231253cc9871be.svg";